import React from 'react'
import { TextSM } from '../../../../Components/Text/NormalText';
import NuDate from '../../../../Components/Utils/NuDate';
import { Link, useParams } from 'react-router-dom';

import { NewPill } from '../../../../Components/Utils/StatusPills';
import ViewMoreCR from './ViewMoreCR';

function CRCard({ item,getData }) {
   
    return (
        <div className="w-full border bg-white rounded-lg shadow-xl mt-1.5 mb-2">
   
        <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
          <p className=" w-8 h-5 bg-slate-300  flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
            {item?.id || "#"}
          </p>
          <div className=" flex items-center gap-3">
            <div className="flex items-center gap-2 overflow-hidden">
              {item?.status &&
               
                  <NewPill text={item?.status} />
              
                }
            </div>
            <ViewMoreCR 
            id={item?.id} 
            getData={getData}
            data={item}
                />
          </div>
        </div>
        <div className=" px-2 pb-2">
          <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
            <Link
              className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
              to={`/client-management/contracts/view/${item?.id}`}
              state={{ data: item }}
            >
              {item?.refNumber || "-"}
            </Link>
          </div>
          <div
            className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
            style={{ border: "1px solid #C0C0C0" }}
          >
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Client : " || "-"} />
                <div className=" text-xs ">{item?.clientName || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Date : " || "-"} />
                <div className=" text-xs ">{(item?.date != "None" && (
                    <NuDate value={item?.date} format="DD-MMM-YY" />
                  )) ||
                    "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"StartDate : " || "-"} />
                <div className=" text-xs ">{(item?.startDate != "None" && (
                    <NuDate value={item?.startDate} format="DD-MMM-YY" />
                  )) ||
                    "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"EndtDate : " || "-"} />
                <div className=" text-xs ">{(item?.endDate != "None" && (
                    <NuDate value={item?.endDate} format="DD-MMM-YY" />
                  )) ||
                    "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Amount : " || "-"} />
                <div className=" text-xs ">{item?.amount || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Status : " || "-"} />
                <div className=" text-xs ">{item?.status || "-"}</div>
              </div>
            </div>
  
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"InspectionDate : " || "-"} />
                <div className=" text-xs ">
                  {(item?. Date != "None" && (
                    <NuDate value={item?. Date} format="DD-MMM-YY" />
                  )) ||
                    "-"}
                </div>
              </div>
            </div> */}
  
           
          </div>
        </div>
      </div>
    );
  }

export default CRCard